import React, { useEffect, useRef, useState } from "react"
import Compressor from "compressorjs"
import axios from "axios"
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, Row, Col } from "reactstrap"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"

const ParcelImagesUploadModel = ({ modal, toggle, ParcelListApi, parcelData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const fileInputRef = useRef(null)
    const [loading, setLoading] = useState(false);
    const [previewUrls, setPreviewUrls] = useState([])
    const [base64Images, setBase64Images] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [deletedUrls, setDeletedUrls] = useState([])
    const [existingUrls, setExistingUrls] = useState([])

    useEffect(() => {
        setPreviewUrls([])
        setBase64Images([])
        setDeletedUrls([])
        setExistingUrls([])
        if (parcelData?.Images) {
            const urls = parcelData.Images.split("|").filter(Boolean)
            setPreviewUrls(urls)
            setExistingUrls(urls)
            setDeletedUrls([]) // reset on open
        }
    }, [parcelData])


    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop1 = async (files) => {
        setLoading(true);
        const acceptedFiles = Array.from(files)

        if (previewUrls.length + acceptedFiles.length > 10) {
            toast.error('Maximum 10 images allowed', {
                style: {
                    fontSize: "15px",
                },
            })
            return
        }

        let newPreviews = []
        let newBase64 = []

        for (const file of acceptedFiles) {

            if (!file.type.startsWith("image/")) continue

            await new Promise((resolve) => {
                new Compressor(file, {
                    quality: 0.4,
                    success: async (compressedResult) => {
                        newPreviews.push(URL.createObjectURL(compressedResult))
                        newBase64.push(await toBase64(compressedResult))
                        resolve()
                    },
                    error: () => resolve()
                })
            })
        }
        setLoading(false);
        setPreviewUrls(prev => [...prev, ...newPreviews])
        setBase64Images(prev => [...prev, ...newBase64])

        fileInputRef.current.value = null
    }

    const removeImage = (index) => {

        const isExisting = index < existingUrls.length
        const removedUrl = previewUrls[index]

        // revoke only blob URLs
        if (!isExisting) {
            URL.revokeObjectURL(removedUrl)
        }

        // remove from preview
        setPreviewUrls(prev => prev.filter((_, i) => i !== index))

        if (isExisting) {
            // ✅ track deleted server URL
            setDeletedUrls(prev => [...prev, removedUrl])
            setExistingUrls(prev => prev.filter((_, i) => i !== index))
        } else {
            const newIndex = index - existingUrls.length
            setBase64Images(prev => prev.filter((_, i) => i !== newIndex))
        }
    }

    const handleSubmit = async () => {

        if (previewUrls.length === 0) {
            toast.error("Please upload at least one image")
            return
        }

        const payload = {
            Id: parcelData?.Id,
            ExistingImages: existingUrls.join("|"), // URLs
            DeleteImagesUrls: deletedUrls.join("|"),
            NewImagesBase64: base64Images.map(img => img.split(",")[1]).join("|") // only base64
        }

        setIsSubmitting(true)

        postApi("Parcel/upload-images", payload).then(({ data, status }) => {
            setIsSubmitting(false)
            if (status == 400) {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            } else {
                toast.success(`Sucessfully uploaded`, {
                    style: {
                        fontSize: "15px",
                    },
                })
                setIsSubmitting(false)
                ParcelListApi?.()
                toggle()

            }
        })
    }

    useEffect(() => {
        return () => {
            previewUrls.forEach(url => URL.revokeObjectURL(url))
        }
    }, [])

    return (
        <Modal isOpen={modal} toggle={toggle} centered size="lg">
            <ModalHeader toggle={toggle}>
                Upload Parcel Images
            </ModalHeader>
            {loading && (
                <div className="loading-overlay is-active">
                    <span className="fas fa-spinner fa-3x fa-spin"></span>
                </div>
            )}
            <ModalBody>

                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    onChange={(e) => handleDrop1(e.target.files)}
                />
                <Button
                    user="primary"
                    className="btn btn-primary btn-sm mb-2"
                    type="button"
                    onClick={() => fileInputRef.current.click()}
                    color="primary"
                >
                    Select Images
                </Button>

                {/* Preview */}
                <div className="d-flex flex-wrap gap-4">
                    {previewUrls.length > 0 && previewUrls.map((url, index) => (
                        <div
                            key={index}
                            style={{ position: "relative", width: "130px", height: "130px" }}
                        >
                            <img
                                src={url}
                                alt="preview"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "2px"
                                }}
                            />

                            {/* Delete */}
                            <span
                                onClick={() => removeImage(index)}
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    background: "#ff4d4f",
                                    color: "#fff",
                                    borderRadius: "2%",
                                    width: "20px",
                                    height: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontWeight: "bold"
                                }}
                            >
                                ×
                            </span>
                        </div>
                    ))}
                </div>
                <Row>
                    <Col md={12} className="mt-2" style={{ display: "flex", justifyContent: "flex-end" }}>
                        {isSubmitting ? (
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                color="secondary"
                            >
                                <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                Loading
                            </button>
                        ) : (
                            <Button
                                user="primary"
                                className="btn btn-primary btn-sm "
                                type="button"
                                onClick={handleSubmit}
                                color="primary"
                            >
                                Submit
                            </Button>
                        )}
                    </Col>
                </Row>
            </ModalBody>

        </Modal>
    )
}

export default ParcelImagesUploadModel
